export var SIGN_IN_PATH = 'auth/signin';
